import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import type { Props as ErrorProps } from '~/core/components/composed/placeholder/Error.vue';
import type { Props as ButtonProps } from '~/core/components/base/button/Simple.vue';

interface Props {
    errorProps: ErrorProps;
    buttonText?: string;
    buttonProps?: ButtonProps;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorWithButton',
  props: {
    errorProps: null,
    buttonText: null,
    buttonProps: { default: () => ({}) }
  },
  emits: ['button-click'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { errorProps: ErrorProps, buttonText?: string, buttonProps: ButtonProps };





const {
    errorProps,
    buttonText,
    buttonProps,
} = toRefs(props);


return { __sfc: true,$emit, props, errorProps, buttonText, buttonProps }
}

})